import { Navigate, useLocation, useParams } from "react-router-dom";

/**
 * Legacy /pipeline/:dealId → /deal-flow/deals/:dealId. Keeps the query string
 * and hash, so a link such as `/pipeline/{id}?tab=underwriting` (the analyst
 * tabs' N/A card) still lands on its tab (Group G, 2026-10-08).
 */
export function RedirectPipelineDeal() {
  const { dealId } = useParams<{ dealId: string }>();
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: `/deal-flow/deals/${dealId}`, search, hash }} replace />;
}
